module.exports = __webpack_public_path__ + "img/m1@2x.b1fc60e3.png";